<template lang="html">
   <div id="app">
        <el-container>
            <el-header class="div-header">
                <Header />
                <el-divider class="header-divider"></el-divider>
            </el-header>
            <div class="main-div">
                <el-container class="main-div parentDiv">
                    <splitpanes class="default-theme defaultStyle custom-splite">
                        <pane size="100" class="SideBarLeft">
                            <!--SID1044 Body Part-->
                            <template>
                                <el-container class="SID1044__Condition">
                                    <div id="SID1044__Container">
                                                <div class="MailDeliveryDestinationList">
                                                    <el-breadcrumb separator-class="el-icon-arrow-right">
                                                       <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                                                        <el-breadcrumb-item :to="{ path: '' }">メールテンプレート管理 </el-breadcrumb-item>
                                                    </el-breadcrumb>                 
                                                </div>
                                        <el-row>
                                            <el-form class="EmailDestinationReg">
                                                <el-form-item >
                                                    <span class="mandatoryMark">*</span> <span class="spanLabel">テンプレート登録</span>
													<span class="alertSpan">{{ Errortext }}</span>
                                                    <el-upload
                                                        class="upload-demo"
                                                        drag
                                                        action="https://jsonplaceholder.typicode.com/posts/"
                                                        :on-preview="handlePreview"
                                                        :on-remove="handleRemove"
                                                        :file-list="fileList"
                                                        accept=".csv,.html,.txt"
                                                        ref="upload"
                                                        :before-upload="beforeAvatarUpload"
                                                        :auto-upload="false"
                                                        >
                                                        <i class="el-icon-upload"></i>
                                                        <div class="el-upload__text">ここにファイルをドロップするか、<em>クリックしてファイルを選択してください。</em></div>
                                                    </el-upload>
                                                </el-form-item>
                                                <el-form-item>
                                                    <!-- // 2023/03/27  #14161  START -->
                                                    <el-button type="primary" plain class="RegButton" @click="register" :disabled="Buttonpressed == 1">登録</el-button>
                                                    <!-- // 2023/03/27  #14161  END -->
                                                </el-form-item>
                                            </el-form>
                                        </el-row>
                                        <el-row class="SID1044__Container__row">
                                            <el-col>
                                                <div class="MailDeliveryDestinationList">
                                                    <div class="labelTitle">テンプレートプレビュー・ダウンロード</div>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20" class="SID1044__Container__row">
                                            <el-form  ref="data_form" :model="data_form">
                                                <el-form-item label="">
                                                    
                                                    <div class="MailDeliveryDestinationList">
                                                        <div class="labelTitle">                          
                                                            <el-select v-model="value_selected" ref="selectedValue"  @change="onChange($event)" placeholder="" v-loading="loading">
                                                                <el-option v-for="item in getdropdown_data"
                                                                    
                                                                    :key="item.value"
                                                                    :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>                                                       
                                                            <el-button type="primary"  @click="Model_popup" plain class="InputButtonDiv ButtonPreview">プレビュー</el-button>                                  
                                                            <el-button type="primary" @click="Download_template" class="leftmargin" plain>ダウンロード</el-button>                         
                                                            <el-button type="danger" class="leftmargin" plain @click="Delete_template">削除</el-button>                      
                                                        </div>
                                                    </div>
                                                </el-form-item>
                                            </el-form>
                                        </el-row>
                                    </div>
                                </el-container>
                            </template>
                            <!--SID1044 Body Part End-->
                        </pane>
                        <pane class="SideBarRight">
                            <SideBar class="SidePane" />
                        </pane>
                    </splitpanes>
                </el-container>
            </div>
            <el-container class="footer-div">
                <el-footer class="footer-element">
                <FooterComponent />
                </el-footer>
            </el-container>
        </el-container>
        <el-dialog class="SID1044_DilaogDiv" title="" :visible.sync="dialogTableVisible" close="false" :close-on-click-modal="false">
			<el-container >
				<div class="SID1044__DialogPopup">
					<!-- Dialog top section -->
					<section>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '1044' }">メール配信先登録</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '' }">メニュー</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '1009' }">メール配信先一覧</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '' }">登録</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '' }">プレビュー</el-breadcrumb-item>
                        </el-breadcrumb>
                        <div class="button_DialogClose">
                            <el-button  type="info" plain  @click="dialogTableVisible = false" >プレビューを閉じる</el-button>
                        </div>	
                        <el-divider class="dialogBottomHeader"></el-divider>						
                    </section>
                    <!-- Dialog top sub section -->
                    
                    <!-- Dialog body content section -->
                    <div class="RestrictUrl" v-if="getFileExtension == 'html'" v-html="gettitle_modal"></div>	
					<div v-else class="RestrictUrl"><pre>{{gettitle_modal}}</pre></div>
                    
                </div>
            </el-container>
		</el-dialog>
    </div>
</template>

<script lang="js">
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import json from '../../components/config.json';
export default  {
    name: 'SID1044',
    components: {
        Header,
        SideBar,
        FooterComponent,
        Splitpanes,
    Pane
    },
    props: [],
    
    data () {
    return {
        // 2023/03/27  #14161  START
        Buttonpressed: 0,
        // 2023/03/27  #14161  END
        loading:false,
        form: {},
        data_form:{
            options:[
            { 
               label: 'copy2.bat (ﾃﾞﾌｫﾙﾄ)',
                value: '1'
            },
            {
               label: 'copy.bat ',
                value: '2'
            }
            ],
        
        },
        value_selected: '',
        dialogTableVisible: false,
        fileList: [],
        Errortext: '',
        SelectedValue :'',
        contract_id:''
      };	
    },
    computed: {
        ...mapGetters("situation1008", [
            "getmodalpopup1",
            "getmodalpopup2",
        ]),
        ...mapGetters("situation1044", [
            "getdropdown_data",
            "getcsv_template"	,
            "gettitle_modal",
            "getdelete_response",			
            "getmessage",
            "gettemplateRegisterResult",
            "getFileExtension",
            "getmessageRegister"	
        ]),
      ...mapGetters("situation0001", [

			"getContractId"
			
		])
    },
    methods:{ 
        Delete_template() {
            this.$LogButtonEvent("1044","Delete");
            this.$LogMethodIN("1044","Deletetemplate");
            var selected_template_id=this.value_selected;
            var deleted_array={
                contract_id:this.contract_id,
                data_section:101,
                template_file_id:selected_template_id
            }
            this.$confirm(json["1044_delete_confirm_message"], json["1044_delete_confirm_message_title"], {
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'キャンセル',
            }).then(()=>{
                this.$store.dispatch('communication1044/delete_template',deleted_array).then(()=>{
                    if(this.getmessage){
                     this.$alert(this.getmessage, json["1044_register_success_title"], {
                    confirmButtonText: 'OK',
                    
                    }).then(()=>{
                        if(this.getmessage == "使用されているメールテンプレートは削除できません。"){
                           // console.log("default template")
                        }else{
                            this.loading= true;
                            this.$store.dispatch('communication1044/Mail_template_dropdown').then(()=>{
                                var getResponse=this.getdropdown_data;
                                var flag=''
                                var default_flag='';
                                this.loading=false;
                                for(var i=0;i<getResponse.length;i++){
                                    flag = getResponse[i].default_flag;
                                    if(flag == true && getResponse[i].value != selected_template_id){
                                        default_flag = getResponse[i].value;
                                        this.value_selected = default_flag;
                                    }else{
                                         this.value_selected = default_flag;
                                    }
                                }
                            });
                        }
                        
                    });}
                });
            });
            this.$LogMethodOut("1044","Deletetemplate");
        },
        onChange(event){
            this.$LogButtonEvent("1044","ThemeSelect");
            this.$LogMethodIN("1044","onChangeTheme");
            this.SelectedValue = event;
             this.$LogMethodOut("1044","onChangeTheme");
        },
        /*
      * Backlog issue related fix
      * Author: BM
      * Backlog Id: BT08460_EXTERNAL-1445
      * To increase the file size up to 1 MB
      */
        beforeAvatarUpload(file) {
            
        var isfile ='';
        const isLt1M = file.size / 1024 / 1024 < 1;

        if (file.type === "application/vnd.ms-excel") {
        isfile=true;
        }
        else if(file.type === "text/html"){
          isfile=true; 
        }
        else if(file.type === "text/plain"){
          isfile=true; 
        }else{
            isfile=false;
        }
        if (!isLt1M) {
        //   this.$message.warning('Avatar picture size can not exceed 2MB!');
        }
        return isfile && isLt1M;
      },
        register() {
            this.$LogButtonEvent("1044","Register");
            this.$LogMethodIN("1044","registerTheme");
            /*
                * Backlog issue related fix
                * Author: BM
                * Backlog Id: BT08460_EXTERNAL-1445
                * To check the extension of the uploaded file
            */
            var split_fileType=this.$refs.upload.uploadFiles[0]["name"].split(".");
            var assign_tempval=split_fileType[1];
            if(this.$refs.upload.uploadFiles == 0){
                this.Errortext="ファイルを選択してください。";
            }else if(assign_tempval === 'csv' || assign_tempval === 'html'  || assign_tempval === 'txt'){
                // 2023/03/27  #14161  START
                this.Buttonpressed= 1;
                // 2023/03/27  #14161  END
                this.Errortext="";
                let csv_name=this.$refs.upload.uploadFiles[0]["name"];
                var csv_file=this.$refs.upload.uploadFiles[0]["raw"];
                let formData = new FormData();
                formData.append('csv_file', csv_file); 
                formData.append('Name',csv_name);
                this.$store.dispatch('communication1044/Mail_template',formData).then(() => {
                    //Clearing the file after upload
                    this.$refs.upload.uploadFiles = []
                    if(this.gettemplateRegisterResult == 0){
                        /*
                        * Author: BM
                        * Noticed while checking another bug fix 1445 
                        */
                        this.$alert(this.getmessageRegister,json["1040_register_success_title"], {
                            confirmButtonText: 'OK'
                        }).then(() =>{
                            this.$store.dispatch('communication1044/Mail_template_dropdown').then(()=>{
                                var getResponse=this.getdropdown_data;
                                var flag=''
                                var default_flag='';
                                for(var i=0;i<getResponse.length;i++){
                                    flag=getResponse[i].default_flag;
                                        if(flag == true){
                                            default_flag=getResponse[i].value;
                                            this.value_selected=default_flag;
                                        }
                                }
                            });
                        });
                        // 2023/03/27  #14161  START
                        this.Buttonpressed= 0;
                        // 2023/03/27  #14161  END
                    }else{
                        this.$alert(this.getmessageRegister,json["1040_register_failure_title"], {
                            confirmButtonText: 'OK'
                        }).then(() =>{
                        // window.location.reload()  
                        });
                        // 2023/03/27  #14161  START
                        this.Buttonpressed= 0;
                        // 2023/03/27  #14161  END
                    }
                })
            }
            else{
                this.Errortext="この種類のファイルは登録できません。";
            }
            this.$LogMethodOut("1044","registerTheme"); 
            },
        
        Download_template(){
            this.$LogButtonEvent("1044","Download");
            this.$LogMethodIN("1044","Downloadtemplate");
            if(this.value_selected){
                var select_id=this.value_selected;
          var options_find=this.getdropdown_data.length;
          var id=[];
          var template_name='';
          for(var i=0;i<options_find;i++){
              id.push(this.getdropdown_data[i].value);
          }
          var index_find=id.indexOf(select_id);
          template_name = this.getdropdown_data[index_find].label;
          var array_For_download={
             contract_id:this.contract_id,
             data_section:2,
             template_file_name:template_name
         }
         
         this.$store.dispatch('communication1044/downloadTemplate',array_For_download);
            }else{
                this.$alert(json["1044_select_empty_message"],"アラート", {
                        confirmButtonText: 'OK',
                });
            }
          this.$LogMethodOut("1044","Downloadtemplate");
        },
        handleRemove() { },
        handlePreview() { },
        Model_popup(){
            this.$LogButtonEvent("1044","Preview");
            this.$LogMethodIN("1044","Modelpopup");
            if(this.value_selected){
                var temp_id=this.value_selected;
            var popup_params={
                template_file_id:temp_id,
                theme_class:''
                
            }
            this.$store.dispatch('communication1044/AID00095_Model',popup_params); 
            this.dialogTableVisible = true
            }else{
            this.$alert(json["1044_select_empty_message"],"アラート", {
                        confirmButtonText: 'OK',
                });
            }
            this.$LogMethodOut("1044","Modelpopup"); 
        }
    },
     beforeCreate(){
        //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
        
    },
    mounted () {
        this.contract_id = this.getContractId
        this.loading=true;
       this.$store.dispatch('communication1044/Mail_template_dropdown').then(()=>{
         var getResponse=this.getdropdown_data;
         var flag=''
         var default_flag='';
         this.loading=false;
         for(var i=0;i<getResponse.length;i++){
            
                flag=getResponse[i].default_flag;
                if(flag == true){
                    default_flag=getResponse[i].value;
                     this.value_selected=default_flag;
                }
             
         }
      
       });   
       
         

       
    },
    created(){
    //For the screen Title
     document.title = "メールテンプレート管理画面";
       }
}
</script>

<style scoped>
@import "1044.css";
</style>